import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-stone-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 w-full grid grid-cols-1 lg:grid-cols-12 gap-12 items-center pt-20 pb-12">
        
        <div className="lg:col-span-5 z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <span className="inline-block text-[11px] font-bold tracking-[0.3em] uppercase text-stone-500 mb-6">
              The Art of Essentialism
            </span>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-stone-900 leading-[1.05] mb-8">
              Botanical <br />
              <span className="italic font-light text-stone-400">Restoration.</span>
            </h1>
            <p className="text-lg md:text-xl text-stone-600 mb-10 max-w-md font-light leading-relaxed">
              Mindful skincare rituals engineered to honor your skin's natural biology and restore lasting radiance.
            </p>
            <div className="flex flex-wrap gap-5">
              <a href="#shop" className="px-10 py-5 bg-stone-900 text-white text-[11px] font-bold tracking-[0.2em] uppercase hover:bg-stone-800 transition-all">
                Shop Collection
              </a>
              <a href="#rituals" className="px-10 py-5 border border-stone-300 text-stone-900 text-[11px] font-bold tracking-[0.2em] uppercase hover:bg-stone-900 hover:text-white transition-all">
                The Rituals
              </a>
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-7 relative h-[500px] lg:h-[700px]">
          <motion.div 
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.5 }}
            className="w-full h-full"
          >
            <img 
              src="https://images.unsplash.com/photo-1612817288484-6f916006741a?q=80&w=1600&auto=format&fit=crop" 
              alt="GlowDock Product Showcase" 
              className="w-full h-full object-cover shadow-2xl"
            />
          </motion.div>
          <div className="absolute -bottom-6 -left-6 hidden md:block bg-white p-8 shadow-xl max-w-xs">
            <p className="text-xs font-serif italic text-stone-500 mb-2">"A masterclass in minimalist efficacy."</p>
            <p className="text-[10px] font-bold tracking-widest uppercase">Vogue Beauty</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;